/** @jsxImportSource react */
export interface IconInfoTileHeaderProps {
  layout: 'iconTop' | 'default';
  heading: string;
  content: string;
}

export default function IconInfoTileHeader({
  layout,
  heading,
  content,
}: IconInfoTileHeaderProps) {
  const fontSize = layout === 'iconTop' ? 'text-xl' : 'text-2xl';
  const fontWeight = layout === 'iconTop' ? 'font-medium' : 'font-bold';
  return (
    <div
      className='flex flex-col'
      data-tp-id='gen-div-73f202a5-e5de-4873-a09d-79955bfe2a20'
    >
      <div
        className={`mb-2 ${fontSize} ${fontWeight} leading-[1.6rem]`}
        data-tp-id='gen-div-a28b0f28-6212-497e-8740-b5a69778cd9d'
      >
        {heading}
      </div>
      <div data-tp-id='gen-div-88554118-d02c-40d1-82de-a2cca7298b06'>
        {content}
      </div>
    </div>
  );
}
